import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { AdvertiserAffiliateService, NotificationService, } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdvertiserAffiliate } from 'src/app/_models';

@Component({
  selector: 'app-advertiser-affiliate-detail',
  templateUrl: './affiliate-detail.component.html'
})
export class AdvertiserAffiliateDetailComponent implements OnInit {
  advertiserId : string;
  affiliate: AdvertiserAffiliate = null;
  loaded = false;
  loading = true;
  processing = false;

  saveNew = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private affiliateSvc: AdvertiserAffiliateService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    this.advertiserId = this.route.snapshot.paramMap.get('id');
    let id = this.route.snapshot.paramMap.get('affId');

    if(id == "-1"){
      this.saveNew = true;
      this.affiliate = new AdvertiserAffiliate();
      this.affiliate.min = 0;
      this.affiliate.max = 0;
      this.affiliate.rate = 100;
      this.loaded = true;
      this.loading = false;
    }else{
      this.saveNew = false;
      this.loadDetail(id);
    }

  }

  save() {
    this.processing = true;
    if (confirm("Are you sure to add this affiliate?")) {
      this.affiliateSvc.addAffiliate(this.advertiserId, this.affiliate).subscribe(data => {
        if (data !== null) {
          if (data.status == 1) {
            this.notification.showSuccess("Affiliate added successfully!", "Added Affiliate");
            this.modalService.dismissAll();
            this.back();
          } else {
            this.notification.showError(data.msg, "Fail add");
          }
        } else {
          this.notification.showError("Failed to add affiliate, please try again later.", "Fail add");
        }
      });
      this.processing = false;
    } else {
      this.processing = false;
    }
  }

  update() {
    this.processing = true;
    if (confirm("Are you sure to update this affiliate?")) {
      this.affiliateSvc.updateAffiliate(this.affiliate).subscribe(data => {
        if (data !== null) {
          if (data.status == 1) {
            this.notification.showSuccess("Affiliate updated successfully!", "Update Affiliate");
            this.modalService.dismissAll();
          } else {
            this.notification.showError(data.msg, "Fail update");
          }

        } else {
          this.notification.showError("Failed to update affiliate, please try again later.", "Fail update");
        }
      });
      this.processing = false;
    } else {
      this.processing = false;
    }
  }

  back() {
    this.router.navigate(['/dashboard/offer-stream/advertiser', this.advertiserId, 'affiliate']);
  }

  private loadDetail(id) {
    this.affiliateSvc.getAffiliate(id).subscribe(data => {
      this.affiliate = data
      this.loaded = true;
      this.loading = false;
    });
  }

}
